export default {
  SET_CHARITIES (state, charities) {
    state.charities = charities
  },
  SET_ACTIVE_CHARITY_INFO (state, charityInfo) {
    state.activeCharityInfo = charityInfo
  },
  SET_UPDATED_ORGANIZATION(state, organizationInfo) {
    if(state.activeCharityInfo.charity_id === organizationInfo.id) {
      const activeCharityInfo = state.activeCharityInfo;

      activeCharityInfo.address = organizationInfo.address
      activeCharityInfo.addons = organizationInfo.addons
      activeCharityInfo.ein = organizationInfo.ein
      activeCharityInfo.logo = organizationInfo.logo
      activeCharityInfo.logo_transparent = organizationInfo.logo
      activeCharityInfo.logo_square = organizationInfo.logo_square
      activeCharityInfo.cover_photo = organizationInfo.cover_photo
      activeCharityInfo.charity_name = organizationInfo.name
      activeCharityInfo.primary_color = organizationInfo.primary_color
      activeCharityInfo.secondary_color = organizationInfo.secondary_color
      activeCharityInfo.website = organizationInfo.website
      activeCharityInfo.facebook_page_id = organizationInfo.facebook
      activeCharityInfo.linkedin = organizationInfo.linkedin
      activeCharityInfo.youtube = organizationInfo.youtube
      activeCharityInfo.instagram = organizationInfo.instagram
      activeCharityInfo.email = organizationInfo.email
      activeCharityInfo.description = organizationInfo.description
      activeCharityInfo.phone_number = organizationInfo.phone_number

      state.activeCharityInfo = activeCharityInfo;
    }
  }
}
